"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityStreamActionMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ListView_1 = require("../../components/ListView");
var MDIcon_1 = require("../../components/MDIcon");
var Popover_1 = require("../../components/Popover");
var react_1 = require("react");
var R = __importStar(require("../../utils/ramda"));
var ActivityStreamActionMenu = function (_a) {
  var activity = _a.activity,
    actions = _a.actions;
  var _b = __read((0, react_1.useState)(false), 2),
    visible = _b[0],
    setVisible = _b[1];
  var menu = (0, jsx_runtime_1.jsx)(ListView_1.ListView, {
    data: actions,
    renderContent: function (action) {
      return (0, jsx_runtime_1.jsx)("span", {
        children: action.label
      });
    },
    onClick: function (action) {
      action.onClick(activity);
      setVisible(false);
    }
  });
  return (0, jsx_runtime_1.jsx)(Popover_1.Popover, __assign({
    arrow: false,
    className: "vsx-activity-stream-action-menu-popover",
    content: menu,
    placement: "bottom-end",
    shown: visible,
    onClickOutside: function () {
      return setVisible(false);
    }
  }, {
    children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      "data-expanded": visible,
      className: "vsx-activity-stream-action-menu-icon",
      cursor: "pointer",
      icon: "dots-vertical",
      size: "1.3em",
      onClick: function () {
        return setVisible(R.not);
      }
    })
  }));
};
exports.ActivityStreamActionMenu = ActivityStreamActionMenu;